import { render, staticRenderFns } from "./MyAgent.vue?vue&type=template&id=52f62630&scoped=true"
import script from "./MyAgent.vue?vue&type=script&lang=js"
export * from "./MyAgent.vue?vue&type=script&lang=js"
import style0 from "./MyAgent.vue?vue&type=style&index=0&id=52f62630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f62630",
  null
  
)

export default component.exports